import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { GuidNameCode } from './guid-name-code.type';
import { LocalDivisionLookup } from './local-division-lookup.type';

const HubLookup = t.intersection(
  [
    GuidNameCode,
    t.type({
      localDivisions: nullable(t.array(LocalDivisionLookup)),
    }),
  ],
  'HubLookup',
);

type HubLookup = t.TypeOf<typeof HubLookup>;
export { HubLookup };
